import { trackCustomEvent } from '../../analytics';

export const brandPageViewEvent = ({ vendorId, brandId, brandPageId }) => {
  trackCustomEvent('Brand Page Viewed', {
    vendor_id: vendorId,
    brand_id: brandId,
    brand_page_id: brandPageId,
  });
};

export const brandPageTileViewEvent = ({
  vendorId,
  brandId,
  brandPageId,
  brandPageTilePosition,
  brandPageTileMediaUrl,
}) => {
  trackCustomEvent('Brand Page Tile Viewed', {
    vendor_id: vendorId,
    brand_id: brandId,
    brand_page_id: brandPageId,
    brand_page_tile_position: brandPageTilePosition,
    brand_page_tile_media_url: brandPageTileMediaUrl,
  });
};

export const brandPageTileClickEvent = ({
  vendorId,
  brandId,
  brandPageId,
  brandPageTilePosition,
  brandPageTileMediaUrl,
  brandPageTileClickTargetUrl,
}) => {
  trackCustomEvent('Brand Page Tile Clicked', {
    vendor_id: vendorId,
    brand_id: brandId,
    brand_page_id: brandPageId,
    brand_page_tile_position: brandPageTilePosition,
    brand_page_tile_media_url: brandPageTileMediaUrl,
    brand_page_tile_click_target_url: brandPageTileClickTargetUrl,
  });
};
